'use client';

import { type SVGProps, useId } from 'react';

/** 每个实例使用独立 gradient id，避免同页多个 SVG 重复 id 或与 Radix Select 卸载顺序叠加导致 url(#…) 失效 */
export const VipIcon = (props: SVGProps<SVGSVGElement>) => {
  const uid = useId().replace(/:/g, '');
  const paint0 = `vip-p0-${uid}`;
  const paint1 = `vip-p1-${uid}`;

  return (
    <svg width="1em" height="1em" fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <linearGradient id={paint0} gradientUnits="userSpaceOnUse" x1="8" x2="8" y1="16" y2="0">
          <stop stopColor="#8C97FF" />
          <stop offset="1" stopColor="#4C63FF" />
        </linearGradient>
        <linearGradient id={paint1} gradientUnits="userSpaceOnUse" x1="8.00146" x2="8.00146" y1="3.65137" y2="11.7764">
          <stop stopColor="#8C97FF" />
          <stop offset="1" stopColor="#E3E7FF" />
        </linearGradient>
      </defs>
      <rect height="16" width="16" fill={`url(#${paint0})`} fillOpacity="0.48" rx="8" />
      <path
        d="M4.16982 11.3273L3.12673 5.59035C3.08837 5.37935 3.34499 5.24489 3.49664 5.39654L5.50146 7.40137L7.81945 3.92438C7.90604 3.7945 8.09689 3.7945 8.18348 3.92438L10.5015 7.40137L12.5063 5.39654C12.6579 5.24489 12.9146 5.37935 12.8762 5.59035L11.8331 11.3273C11.7858 11.5874 11.5594 11.7764 11.2951 11.7764H4.70787C4.44358 11.7764 4.2171 11.5874 4.16982 11.3273Z"
        fill={`url(#${paint1})`}
      />
    </svg>
  );
};
